import './bookingTable.css';
// import '../../dashboard/dashboardTable/dashboardTable.css';
import { useState } from 'react';
import { standardDate } from '../../../../utils/formatDate';
import CancelBooking from '../../../tripStrap/tripStrapFun/cancelBooking';
import { orgBookingCancelFun } from '../../../../api/orgTripAPI';
import { toast } from 'react-toastify';
import errorHandle from '../../../../utils/errorHandle';
import { CancelTrip } from '../../../tripStrap/tripStrapFun/cancelBooking';

//pagination not required as we are populating data from bookingId array.
//And data wont reach more than 200
export default function BookingTable({ bookingData, tripStatus, setLoading, refresh }) {
    const tableHeader = [
        'Date',
        'Name',
        // 'Vehicle',
        'Start City',
        'Pick Up',
        'Seats',
        // 'Transport',
        'Booked Via',
        // 'People',
        `${tripStatus === 'Upcoming' ? 'Action' : ''}`
    ];
    const [showModal, setShowModal] = useState(false);
    const [rowId, setRowId] = useState('');
    const sortedBookingData = bookingData.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

    const getUserData = (row) => {
        return row.userDetails.map(function (user, userKey) {
            return (
                <div key={userKey}>
                    <span>{user?.name ?? 'N/A'}, </span>
                    <span>{user?.age ?? 'N/A'}, </span>
                    <span>{user?.sex ?? 'N/A'}, </span>
                    <span>{user?.phoneNumber ?? 'N/A'}</span>
                </div>
            );
        });
    };

    const getVehicleData = (row) => {
        return (
            <div key={row._id} className='vehicleDataDiv'>
                <div>
                    <span>Mode :</span> {row.vehicle?.mode ?? 'N/A'},{' '}
                </div>
                <div>
                    <span>Model :</span> {row.vehicle?.model ?? 'N/A'},{' '}
                </div>
                <div>
                    <span>Empty Seats :</span> {row.vehicle?.emptySeats ?? 'N/A'},
                </div>
                <div>
                    <span>Comfortable :</span> {row.vehicle?.comfortable ?? 'N/A'}
                </div>
            </div>
        );
    };

    async function handleBookingCancel(e) {
        e.stopPropagation();
        setLoading(true);

        try {
            const newDate = await orgBookingCancelFun({ bookingId: rowId });
            if (newDate.status === 200) {
                toast.success('Successfully cancelled Booking');
                setShowModal(false);
                refresh();
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            errorHandle(error);
        }
    }

    return (
        <div className='tripDateContainer'>
            <div className='tableContainer'>
                <table className='table'>
                    <thead className='tableHead'>
                        <tr>
                            {tableHeader.map((head, headKey) => {
                                return <th key={headKey}>{head}</th>;
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {sortedBookingData.map((row, rowKey) => {
                            return (
                                <tr className='tableBodyRow' key={rowKey}>
                                    <td>{standardDate(row?.startDate)}</td>
                                    <td className='tripDateNameRow'>{row?.userDetails[0]?.name ?? 'N/A'}</td>
                                    {/* <td>{getVehicleData(row)}</td> */}
                                    <td>{row?.startCity ?? 'N/A'}</td>
                                    <td>{row?.pickupLocation ?? 'N/A'}</td>
                                    <td>{row?.totalSeats ?? '0'}</td>
                                    {/* <td>{row?.transport ?? 'N/A'}</td> */}
                                    <td>{row?.bookedVia ?? 'N/A'}</td>
                                    {/* <td>{getUserData(row)}</td> */}
                                    {tripStatus === 'Upcoming' ? (
                                        <td>
                                            <span
                                                className='cancelTrip-btn'
                                                onClick={() => {
                                                    setShowModal(true);
                                                    setRowId(row._id);
                                                }}
                                            >
                                                Cancel
                                            </span>
                                        </td>
                                    ) : (
                                        <></>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <div className='responsiveCardContainer'>
                    {bookingData?.map((row, rowIndex) => (
                        <div key={rowIndex} className={`responsiveCard ${row?.tripStatus?.toLowerCase()}`}>
                            <div className='cardContent'>
                                <h3>{row.userDetails[0].name}</h3>
                                <p>
                                    <strong>{tableHeader[2]}:</strong>
                                    {getVehicleData(row)}
                                </p>
                                <p>
                                    <strong>{tableHeader[3]}:</strong> {row?.stratCity ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[4]}:</strong> {row?.pickupLocation ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[5]}:</strong>{' '}
                                    {standardDate(row?.createdAt?.split('T')[0]) ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[6]}:</strong> {row?.totalSeats ?? '0'}
                                </p>
                                <p>
                                    <strong>{tableHeader[7]}:</strong> {row?.transport ?? 'N/A'}
                                </p>
                                <p>
                                    <strong>{tableHeader[8]}:</strong> {row?.bookedVia ?? 'N/A'}
                                </p>
                                <p className={`cardLabelDisplay ${row.userDetails.length > 1 ? 'multiple' : ''}`}>
                                    <strong>{tableHeader[9]}:</strong> {getUserData(row)}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {showModal && (
                <CancelBooking
                    setShowModal={setShowModal}
                    refundAmount={{ refAmount: 5000 }}
                    handleConfirm={(e) => {
                        handleBookingCancel(e);
                    }}
                />
            )}
        </div>
    );
}
